import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-18',
  templateUrl: './18.component.html',
})
export class VbGeneral18Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
